import { ContractModel, ContractStatus } from '../contract/types';
import { LeadDetailModel, LeadModel, LeadStatus } from '../lead/types';
import { BankAccountModel } from '../bank-account/types';
import { DocumentModel } from '../document/types';
import {
  AccountMoveModel,
  AccountMoveTabDetailModel,
} from '../accounting/types';
import { Action } from '../view/types';
import { InsuranceClaimModel } from '../insurance-claim/types';
import { CallTabDetailsListItem } from '../telephony/call/types';

export const contactFeatureKey = 'contact';

export type ContactFormModel = {
  id: number;
  name: string;
  picturePath?: string;
  parentId?: number;
  firstName: string;
  lastName: string;
  titleId: number;
  addressType: number;
  isCompany: boolean;
  address: string;
  address2: string;
  zipCode: string;
  city: string;
  countryId?: number;
  phoneNumber: string;
  mobilePhoneNumber: string;
  email: string;
  profession: string;
  campaignId?: number;
  mediumId?: number;
  sourceId?: number;
  creationTime: Date;
  referrerId: number;
  salesTeamId?: number;
  salesPersonId?: number;
  notes: string;
  pictureId: number;
  uniqueId: string;
};

export type ContactDetailModel = {
  id: number;
  firstName: string;
  lastName: string;
  isCompany: boolean;
  parentId?: number;
  parentName: string;
  picturePath?: string;
  title: string;
  titleName: string;
  name: string;
  profession: string;
  phoneNumber: string;
  mobilePhoneNumber: string;
  email: string;
  address: string;
  address2: string;
  zipCode: string;
  city: string;
  countryId?: number;
  countryName: string;
  salesTeamName: string;
  salesPersonName: string;
  campaignId?: number;
  campaignName: string;
  mediumId?: number;
  mediumName: string;
  sourceId?: number;
  sourceName: string;
  notes: string;
  creationTime: Date;
  referrerId?: number;
  referrerName: string;

  leads: ContactDetailLeadModel[];
  contracts: ContactDetailContractModel[];
  documents: ContactDetailDocumentModel[];
  bankAccounts: ContactDetailBankAccountModel[];
  referees: RefereeModel[];
  accountMoves: AccountMoveTabDetailModel[];
  clientAccountMoves: AccountMoveTabDetailModel[];
  insuranceClaims: InsuranceClaimModel[];
  calls: CallTabDetailsListItem[];
};

export type ContactDetailLeadModel = {
  id: number;
  uniqueId: string;
  salesPersonContactName: string;
  salesTeamName: string;
  campaignName: string;
  creationDate: Date;
  contactId?: number;
  probability: number;
  quotesCount: number;
  productCategoryName: string;
  leadStatus: LeadStatus;
  leadStatusLoc: string;
};

export type ContactDetailContractModel = {
  id: number;
  uniqueId: string;
  productCategoryName: string;
  name: string;
  productProductLineInsuranceCompanyContactName: string;
  productProductLineName: string;
  productName: string;
  salesPersonContactName: string;
  campaignName: string | undefined;
  creationDate: Date;
  statusId: ContractStatus;
  statusLoc: string;
  statusColor: string;
};

export type ContactDetailBankAccountModel = {
  id: number;
};

export type ContactDetailDocumentModel = {
  id: number;
  name: string;
  documentTypeName: string;
  size?: number;
  creationDate: Date;
  actions: Action[];
};

export type ContactModel = {
  id: number;
  title: string;
  titleId: number;
  titleName: string;
  name: string;
  lastName: string;
  firstName: string;
  profession: string;
  phoneNumber: string;
  mobilePhoneNumber: string;
  email: string;
  address: string;
  address2: string;
  zipCode: string;
  city: string;
  countryId?: number;
  countryName: string;
  isCompany: boolean;
  salesPersonId?: number;
  salesPersonName: string;
  campaignId?: number;
  campaignName: string;
  mediumId?: number;
  mediumName: string;
  sourceId?: number;
  sourceName: string;
  addressType: number;
  addressTypeLoc?: string;
  gender?: number;
  genderLoc?: string;
  parentId?: number;
  parentName: string;
  notes: string;
  salesTeamId?: number;
  salesTeamName: string;
  creationTime: Date;
  bankAccount?: BankAccountModel;
  uniqueId: string;
  pictureId?: number;
  picturePath?: string;
  pictureFile?: File;
  contracts: ContractModel[];
  leads: LeadDetailModel[];
  bankAccounts: BankAccountModel[];
  documents: DocumentModel[];
  accountMoves: AccountMoveModel[];
  clientAccountMoves: AccountMoveModel[];
  contractsCount: number;
  leadsCount: number;
  isEmployee: boolean;
  isInsuranceCompany: boolean;
  isUser: boolean;
  referrerId: number;
  referrerName: string;
  referees: RefereeModel[];
};

export type ContactChildrenLightModel = {
  isEmployee: boolean;
  isCompany: boolean;
  parentName: string;
  name: string;
  city: string;
  zipCode: string;
  email: string;
};

export type RefereeModel = {
  id: number;
  name: string;
  contactId: number;
  contractUniqueId: string;
  contractName: string;
  contractStatus: ContractStatus;
  contractStatusLoc: string;
  reward: number;
  comment: string;
};

export type ContactNameModel = {
  id: number;
  name: string;
};
